<template>
  <div class="app-main-content">
    <destination-business-tree-grid
      ref="treeGrid"
      :menu-type="menuType"
      :can-edit="canEdit"
    />
  </div>
</template>

<script>
import destinationBusinessTreeGrid from './components/destinationBusinessTreeGrid'
import { ErrorTip } from '@/utils/class/ErrorTip'

export default {
  name: 'OverseaTracking',
  components: { destinationBusinessTreeGrid },
  data() {
    return {
      menuType: 'overseaTracking'
    }
  },
  computed: {
    canEdit() {
      return this.$checkPermission(['button_OverseaTrackingEdit'])
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  }
}
</script>

<style lang="scss">
</style>
